var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "forget-container" },
    [
      _c(
        "el-form",
        {
          ref: "forgetForm",
          staticClass: "forget-form",
          attrs: {
            model: _vm.forgetForm,
            rules: _vm.forgetRules,
            "auto-complete": "on",
            "label-position": "left",
          },
        },
        [
          _c("div", { staticClass: "title-container" }, [
            _c("h3", { staticClass: "title" }, [_vm._v("Forget Password")]),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { prop: "email" } },
            [
              _c(
                "span",
                { staticClass: "svg-container" },
                [_c("svg-icon", { attrs: { "icon-class": "user" } })],
                1
              ),
              _vm._v(" "),
              _c("el-input", {
                ref: "email",
                attrs: {
                  placeholder: "Email",
                  name: "email",
                  type: "email",
                  tabindex: "1",
                  "auto-complete": "on",
                },
                model: {
                  value: _vm.forgetForm.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.forgetForm, "email", $$v)
                  },
                  expression: "forgetForm.email",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "forget-link" },
            [
              _c("router-link", { attrs: { to: "/login" } }, [
                _vm._v(_vm._s(_vm.$t("PurchaseRequests.Back"))),
              ]),
              _vm._v(" "),
              _c("br"),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { width: "100%", "margin-bottom": "30px" },
              attrs: { loading: _vm.loading, type: "primary" },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.handleSubmit($event)
                },
              },
            },
            [_vm._v("Send")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }